import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { EmailLogObjectType } from "@/model/Enums";

export interface IEmailLogItem {
    id: number;
    awsMessageID: string;
    objectType: EmailLogObjectType;
    objectID: number;
    created: Date;
    updated: Date;
    info: string;
    recipients: string;
    subject: string;
    body: string;
    result: string;
    snsRequestBody: string;
}

export class EmailLogItem implements IEmailLogItem {

    constructor(data?: IEmailLogItem) {
        if (data) this.update(data);
    }

    update(data: IEmailLogItem): EmailLogItem {
        mapData(data, { root: () => this });
        return this;
    }

    id: number = 0;
    awsMessageID: string = "";
    objectType: EmailLogObjectType = EmailLogObjectType.None;
    objectID: number = 0;
    created: Date = new Date(Utils.emptyDateValue);
    updated: Date = new Date(Utils.emptyDateValue);
    info: string = "";
    recipients: string = "";
    subject: string = "";
    body: string = "";
    result: string = "";
    snsRequestBody: string = "";

    get isNew() {
        return this.id === 0;
    }

    get isSuccess() {
        return this.result.toLowerCase() === "sent";
    }
}
